import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Select from 'react-select'
import classNames from 'classnames'
import { durations } from 'const'
import Button, { icons } from 'components/Button'
import './Lesson.css'

const ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="11">
<path fill="#9B9B9B" fill-rule="nonzero" d="M6.248 5.579l3.494-3.494A.882.882 0 0 0 8.494.837L5 4.331 1.506.837A.882.882 0 1 0 .258 2.085L3.753 5.58.26 9.073a.882.882 0 1 0 1.248 1.248L5 6.826l3.494 3.494a.882.882 0 0 0 1.248-1.248L6.247 5.579z"/>
</svg>`;


class Lesson extends Component {
    
    setNewValue = (type, value, index = null) => {
        const {
            onChange,
            ...rest
        } = this.props

        let payload = { ...rest }
        if(type === 'price' || type === 'priceGroup'){
            const newPrices = payload.prices.map((item, i) => {
                return index !== i ? item : {...item, [type]: value}
            })
            payload = {...payload, prices: newPrices}
        }
        else{
            payload = {...payload, [type]: value}
        }
        
        onChange(payload)
    }

    addPriceGroup = (event, type) => {
        event.preventDefault()
        const { addPriceGroup } = this.props
        addPriceGroup(type)
    }
    
    removePriceGroup = (event, type, index) => {
        event.preventDefault()
        const { removePriceGroup } = this.props
        removePriceGroup(type, index)
    }

    render() {
        const {
            index,
            title,
            enabled,
            duration,
            editableDuration,
            type,
            prices,
            currency = '€',
            description,
            toggleLesson,
            custom = false,
        } = this.props

        
        const cls = classNames('lesson', {'lesson__open': enabled, 'lesson__closed': !enabled})

        
        if(!enabled){
            return (
                <div className={cls}>
                    <Row className="form--row">
                        <Col xs={12}>
                            <div className="form-group">
                                <label><input checked={enabled} onChange={ event => toggleLesson({type: type}) } type="checkbox" />&nbsp; {custom ? type : title}</label>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }
        
        return (
            <div className={cls}>
                <Row className="form--row">
                    <Col xs={12}>
                        <div className="form-group">
                            <label><input checked={enabled} onChange={ event => toggleLesson({type: type}) } type="checkbox" />&nbsp; {custom ? type : title}</label>
                        </div>
                            {
                                custom && (
                                    <div className="form-group">
                                        <label className="label" htmlFor={`title-${index}`}>Lesson title</label>
                                        <input
                                            onChange={event => this.setNewValue('title', event.target.value)}
                                            required
                                            placeholder="e.g. Private lesson 30 min"
                                            type="text" 
                                            id={`title-${index}`} 
                                            name={`title-${index}`} 
                                            defaultValue={title}
                                        />
                                    </div>
                                )
                            }
                    </Col>
                </Row>
                { editableDuration && (
                    <Row className="form--row">
                        <Col xs={12}>
                            <div className="form-group">
                                <label className="label" htmlFor={`duration-${index}`}>Lesson duration</label>
                                <br />
                                <div data-postfix="min" className="postfix--select">
                                <Select
                                    onChange={option => this.setNewValue('duration', option.value)}
                                    name={`duration-${index}`}
                                    id={`duration-${index}`}
                                    options={durations}
                                    value={duration}
                                    clearable={false}
                                    required
                                />
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
                <Row className="form--row">
                  <Col xs={12}>
                    <div className="form-group">
                      <label className="label" htmlFor={`description-${index}`}>
                        Lesson description
                      </label>
                      <textarea 
                        required
                        onChange={event => this.setNewValue('description', event.target.value)} 
                        id={`description-${index}`} 
                        name={`description-${index}`} 
                        defaultValue={description}
                      />
                    </div>
                  </Col>
                </Row>
                { prices.map((item, index) => (
                    <Row className="form--row" key={`${item.id}`}>
                        <Col xs={6}>
                        <div className="form-group">
                            <label className="label" htmlFor={`price-${index}`}>Lesson price</label>
                            <br />
                            <span data-postfix={currency}>
                                <input 
                                    onChange={event => this.setNewValue('price', event.target.value, index)}
                                    required
                                    max={10000}
                                    type="number" 
                                    id={`price-${index}`} 
                                    name={`price-${index}`} 
                                    value={item.price} 
                                />
                            </span>
                        </div>
                        </Col>
                        <Col xs={6}>
                            <div className="form-group form-group__with-extras">
                            <label className="label" htmlFor={`priceGroup-${index}`}>Price type</label>
                            <br />
                            <input 
                                onChange={event => this.setNewValue('priceGroup', event.target.value, index)}
                                required={prices.length > 1 ? true : undefined}
                                type="text" 
                                id={`priceGroup-${index}`} 
                                name={`priceGroup-${index}`} 
                                defaultValue={item.priceGroup}
                                placeholder="e.g. member, visitor, junior"
                            />
                            { index > 0 && (
                                <button className="button button__unstyled price--delete" onClick={event => this.removePriceGroup(event, type, item.id)}>
                                    DELETE <span className="price--delete-icon" dangerouslySetInnerHTML={{__html: ICON}} />
                                </button>
                            )
                             }
                        </div>
                        </Col>
                    </Row>
                    )
                )}
                    <Row className="form--row" key={index}>
                        <Col xs={12}>
                            <Button type="button" className="button__thin" icon={icons.PLUS} prependIcon={true} buttonType="ghost" onClick={event => this.addPriceGroup(event, type) }>
                                Add other price type (member, visitor, junior etc.)
                            </Button>
                        </Col>
                    </Row>
                
            </div>
        )
    }
}

export default Lesson



// WEBPACK FOOTER //
// ./src/components/Lessons/Lesson.js